import { Component, inject, input, output, signal, TemplateRef, viewChild, ViewContainerRef } from "@angular/core";
import type { Category } from "@ophardt/shopware-api";
import { BottomDrawerService } from "@shared/services/bottom-drawer.service";
import { takeUntilDestroyed, toSignal } from "@angular/core/rxjs-interop";
import { bottomSlideAnimation } from "@shared/animations/bottom-slide.animation";
import { IconComponent } from "@shared/components/atoms/icon/icon.component";
import { TranslatePipe } from "@ngx-translate/core";
import { CategoryNavigationTreeComponent } from "@features/products/components/category-navigation-tree/category-navigation-tree.component";
import { ActivatedRoute } from "@angular/router";
import { map } from "rxjs";

@Component({
  selector: "app-mobile-category-drawer",
  templateUrl: "./mobile-category-drawer.component.html",
  styleUrl: "./mobile-category-drawer.component.scss",
  animations: [bottomSlideAnimation],
  providers: [BottomDrawerService],
  imports: [IconComponent, TranslatePipe, CategoryNavigationTreeComponent],
})
export class MobileCategoryDrawerComponent {
  categoryList = input.required<Category[]>();
  categoryChanged = output<Category>();

  private readonly route = inject(ActivatedRoute);

  currentCategory = toSignal(this.route.queryParamMap.pipe(map((params) => params.get("category") ?? "")), { initialValue: "" });
  drawerTemplate = viewChild.required<TemplateRef<unknown>>("drawerTemplate");
  isOpen = signal<boolean>(false);

  private readonly bottomDrawerService = inject(BottomDrawerService);
  private readonly viewContainerRef = inject(ViewContainerRef);

  constructor() {
    this.listenDrawerOpenState();
  }

  toggle(): void {
    if (!this.bottomDrawerService.isOpen()) {
      this.open();
    } else {
      this.close();
    }
  }

  open(): void {
    this.bottomDrawerService.open(this.drawerTemplate(), this.viewContainerRef);
  }

  close(): void {
    this.bottomDrawerService.close();
  }

  onCategoryChanged(category: Category): void {
    this.categoryChanged.emit(category);
    this.close();
  }

  private listenDrawerOpenState(): void {
    this.bottomDrawerService.isOpen$.pipe(takeUntilDestroyed()).subscribe((isOpen) => {
      this.isOpen.set(isOpen);
    });
  }
}
